// src/pages/cliente/TicketView.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { get } from '../../helpers/apiHelper';
import Swal from 'sweetalert2';
import TicketViewContent from '../../components/public/TicketViewContent';
import ticketCustomizationService from '../../helpers/ticketCustomizationHelper';

// Valores por defecto para cuando falten datos de marca (disponibles para personalización)
// const DEFAULT_BRAND_COLORS = {
//   primary: '#3B82F6',
//   secondary: '#1D4ED8',
//   text: '#ffffff',
//   background: '#F3F4F6'
// };

// const DEFAULT_FONT = 'system-ui';

// CSS inline para animaciones de confeti
const confettiStyles = {
  position: 'absolute',
  width: '0.5rem',
  height: '0.5rem',
  borderRadius: '9999px',
  animation: 'confettiFall 2.5s ease forwards',
};

// Componente de confeti para animaciones (disponible para personalización)
// const Confetti = () => {
//   const particles = 30; // Aumentado para más efecto
//   const colors = ['bg-brand-primary', 'bg-brand-secondary', 'bg-yellow-400', 'bg-green-400', 'bg-purple-400'];

//   const confettiElements = Array.from({ length: particles }, (_, i) => {
//     const left = Math.random() * 100;
//     const delay = Math.random() * 0.5;
//     const color = colors[Math.floor(Math.random() * colors.length)];
//     const size = 6 + Math.random() * 8;

//     return (
//       <div
//         key={i}
//         className={`confetti absolute ${color}`}
//         style={{
//           ...confettiStyles,
//           top: '0%',
//           left: `${left}%`,
//           animationDelay: `${delay}s`,
//           width: `${size}px`,
//           height: `${size}px`,
//         }}
//       />
//     );
//   });

//   return (
//     <div className="pointer-events-none absolute inset-0 overflow-hidden" style={{ zIndex: 999 }}>
//       {confettiElements}
//       <style>{`
//         @keyframes confettiFall {
//           0% {
//             transform: translateY(0) rotate(0deg);
//             opacity: 1;
//           }
//           100% {
//             transform: translateY(150vh) rotate(720deg);
//             opacity: 0;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

const LoadingSpinner = () => (
  <div className="flex items-center justify-center h-screen bg-gradient-to-br from-gray-50 to-gray-100">
    <div className="text-center">
      <div className="w-16 h-16 border-4 border-brand-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <div className="text-xl text-gray-700 font-medium">Cargando tu ticket...</div>
      <p className="text-gray-500 mt-2">Espera un momento por favor</p>
    </div>
  </div>
);

const ErrorView = () => (
  <div className="flex items-center justify-center h-screen bg-gradient-to-br from-gray-50 to-gray-100">
    <div className="text-center max-w-md mx-auto p-6 bg-white rounded-xl shadow-lg">
      <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>
      <div className="text-xl text-red-600 font-semibold mb-2">Ticket no encontrado</div>
      <p className="text-gray-600">Lo sentimos, el ticket que buscas no existe o ha sido eliminado</p>
    </div>
  </div>
);

const TicketView = () => {
  const { ticketUrl } = useParams();
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [customization, setCustomization] = useState(null);
  const [texts, setTexts] = useState({});
  const [styles, setStyles] = useState({});
  const [layout, setLayout] = useState('wallet');
  const [layoutOptions, setLayoutOptions] = useState({});
  const [heroImage, setHeroImage] = useState(null);

  /* Función para añadir al wallet - Temporalmente deshabilitada
  const addToWallet = async (ticketId) => {
    try {
      // Mejor detección de dispositivos iOS
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) &&
        !window.MSStream; // Excluye IE11

      if (isIOS) {
        try {
          // Usar getBlob de apiHelper que ya maneja el token y los headers
          const blob = await getBlob(`wallet/apple-pass/${ticketId}`, {
            headers: {
              'Accept': 'application/vnd.apple.pkpass'
            }
          });

          // Crear y abrir la URL del blob
          const url = window.URL.createObjectURL(blob);
          window.location.href = url;

          // Limpiar la URL después de un momento
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 1000);

          // Mostrar mensaje de éxito
          Swal.fire({
            title: 'Éxito',
            text: 'Abriendo Apple Wallet...',
            icon: 'success',
            timer: 2000,
            showConfirmButton: false
          });
        } catch (error) {
          throw new Error('Error al obtener el pass de Apple Wallet');
        }
      } else {
        // Detectar si es Android
        const isAndroid = /Android/.test(navigator.userAgent);

        if (isAndroid) {
          try {
            const response = await get(`wallet/google-pass/${ticketId}`);

            if (!response) {
              throw new Error('Google Wallet no disponible');
            }

            Swal.fire({
              title: 'Google Wallet',
              html: `
                La integración con Google Wallet estará disponible próximamente.<br>
                Mientras tanto, puedes acceder a tu tarjeta desde el navegador.
              `,
              icon: 'info',
              showCancelButton: true,
              confirmButtonText: 'Entendido',
              cancelButtonText: 'Ver en navegador'
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.cancel) {
                window.location.href = currentTicketUrl;
              }
            });
          } catch (error) {
            console.error('Error con Google Wallet:', error);
            Swal.fire({
              title: 'Google Wallet',
              text: error.message,
              icon: 'error',
              showCancelButton: true,
              confirmButtonText: 'Aceptar',
              cancelButtonText: 'Ver en navegador'
            }).then((result) => {
              if (result.dismiss === Swal.DismissReason.cancel) {
                window.location.href = currentTicketUrl;
              }
            });
          }
        } else {
          // Para otros dispositivos (Windows, etc)
          Swal.fire({
            title: 'Dispositivo no compatible',
            text: 'Esta función solo está disponible para dispositivos iOS y Android',
            icon: 'warning',
            confirmButtonText: 'Ver en navegador'
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.href = currentTicketUrl;
            }
          });
        }
      }
    } catch (error) {
      console.error('Error al añadir al wallet:', error);

      Swal.fire({
        title: 'Error',
        text: error.message || 'No se pudo añadir la tarjeta al wallet',
        icon: 'error',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Ver en navegador'
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.cancel) {
          window.location.href = currentTicketUrl;
        }
      });
    }
  };
  */
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!ticketUrl) {
          throw new Error('URL del ticket no proporcionada');
        }

        // Obtener ticket
        const ticketResponse = await get(`tickets/url/${ticketUrl}`);
        setTicket(ticketResponse);

        // Obtener personalización de la marca si existe
        if (ticketResponse?.marca?._id) {
          try {
            const customizationResponse = await ticketCustomizationService.getCustomization(ticketResponse.marca._id);

            // El backend puede devolver { success: true, customization: {...} } o directamente el objeto
            let ticketCustomizationData = customizationResponse;
            if (customizationResponse?.customization) {
              ticketCustomizationData = customizationResponse.customization;
            }

            // Normalizar datos (puede venir como objeto Mongoose)
            const processedCustomization = ticketCustomizationData._doc || ticketCustomizationData;

            if (processedCustomization) {
              setCustomization(processedCustomization);

              // Aplicar textos
              if (processedCustomization.texts) {
                setTexts(processedCustomization.texts);
              }

              // Aplicar estilos
              if (processedCustomization.styles) {
                setStyles(processedCustomization.styles);
              }

              // Aplicar layout
              if (processedCustomization.layout) {
                setLayout(processedCustomization.layout);
              }

              // Aplicar layoutOptions
              if (processedCustomization.layoutOptions) {
                setLayoutOptions(processedCustomization.layoutOptions);
              }

              // Aplicar imagen hero
              if (processedCustomization.heroImage) {
                setHeroImage(processedCustomization.heroImage);
              }
            }
          } catch (error) {
            // Si no hay personalización (404), es normal, usar valores por defecto
            if (error.status !== 404) {
              console.warn('Error obteniendo personalización de tarjeta:', error);
            }
          }
        }
      } catch (error) {
        Swal.fire({
          title: 'Error',
          text: error.message || 'No se pudo cargar el ticket',
          icon: 'error',
          confirmButtonText: 'Aceptar',
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [ticketUrl]);

  if (loading) return <LoadingSpinner />;
  if (!ticket) return <ErrorView />;

  const handleShare = () => {
    const shareData = {
      title: texts.shareTitle || 'Mi Tarjeta de Fidelización',
      text: texts.shareText || `Tarjeta de ${ticket.marca?.nombre}`,
      url: window.location.href
    };
    if (navigator.share) {
      navigator.share(shareData);
    } else {
      navigator.clipboard.writeText(window.location.href);
      Swal.fire({
        title: 'Enlace copiado',
        text: 'El enlace de la tarjeta ha sido copiado al portapapeles',
        icon: 'success',
        timer: 2000,
        showConfirmButton: false
      });
    }
  };

  return (
    <TicketViewContent
      ticket={ticket}
      texts={texts}
      styles={styles}
      layout={layout}
      layoutOptions={layoutOptions}
      heroImage={heroImage}
      onShare={handleShare}
      isPreview={false}
    />
  );
};

export default TicketView;
